var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthorizations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.14 130.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.56,130.09h75.03c.41-.01.81-.05,1.21-.09H12.34c.4.05.8.08,1.21.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.14,115.95v-14.05h0v-32.26c0-2.56-2.08-4.64-4.64-4.64h-4.65V18.57c0-1.23-.49-2.41-1.36-3.28l-13.93-13.93C76.7.49,75.52,0,74.28,0H13.93c-2.56,0-4.64,2.08-4.64,4.64v51.07h-4.64c-2.56,0-4.63,2.07-4.64,4.63v55.61c-.11,7.22,5.29,13.25,12.34,14.05h77.46c7.05-.8,12.45-6.83,12.34-14.05Zm-35.75-24.95l-13.92,18.57c-.13.18-.27.34-.43.5-1.81,1.81-4.76,1.81-6.57,0l-9.29-9.29h0c-1.81-1.81-1.81-4.75,0-6.56s4.75-1.81,6.56,0l5.5,5.5,10.72-14.29c1.54-1.99,4.37-2.39,6.4-.91,2.07,1.51,2.53,4.41,1.02,6.49Zm17.18-26h-31.09s-12.76-8.5-12.76-8.5c-.76-.51-1.66-.78-2.58-.78h-18.57V9.29h53.79l11.21,11.21v44.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.79,40.1H31.31c-1.29.03-2.33,1.07-2.36,2.36-.03,1.33,1.03,2.43,2.36,2.45h39.48s.06,0,.1,0c1.33-.03,2.38-1.13,2.36-2.45-.03-1.33-1.13-2.38-2.45-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.21,22.84c-1.33.03-2.38,1.13-2.36,2.46.03,1.33,1.13,2.38,2.46,2.36h39.57c1.33-.03,2.38-1.13,2.36-2.46-.03-1.33-1.13-2.38-2.46-2.36H31.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizations);
export default __webpack_public_path__ + "static/media/Authorizations.89339e43b1be774f0df2197eb5e3d1c4.svg";
export { ForwardRef as ReactComponent };